var primaryButtonFontColor = theme => theme.__type === 'primary' || theme.__type === 'tertiary' ? theme.COLORS.white : theme.COLORS.primary;
var primaryButtonBackgroundColor = (theme, buttonColor) => {
  if (buttonColor === theme.COLORS.primary && theme.__type === 'secondary') {
    return theme.COLORS.secondary;
  } // If buttonColor is not COLORS.primary then it is custom, return as is


  return buttonColor;
};
var primaryButtonLoadingBackgroundColor = theme => theme.__type === 'primary' || theme.__type === 'tertiary' ? theme.COLORS.white : theme.COLORS.primary;
/**
 * We use theme.FONTS.baseFont for all primary styles, but use a
 * different secondary font for Display, Heading, and Title styles
 */

var setSecondaryHeadingFont = theme => theme.__type === 'secondary' ? "font-family: ".concat(theme.FONTS.headerFont, ";") : '';
var setButtonStyleFontWeight = theme => theme.__type === 'primary' || theme.__type === 'tertiary' ? "font-weight: ".concat(theme.TYPOGRAPHY.fontWeight.bold, ";") : '';
var setThemeLineHeight = (theme, primaryLineHeight) => theme.__type === 'secondary' ? '1.4' : primaryLineHeight;
var setThemeFontWeight = theme => theme.__type === 'secondary' ? theme.TYPOGRAPHY.fontWeight.normal : theme.TYPOGRAPHY.fontWeight.bold;
var applyPrimaryThemeVerticalOffset = function applyPrimaryThemeVerticalOffset(theme, offset) {
  if (offset === void 0) {
    offset = '1';
  }

  return theme.__type === 'primary' || theme.__type === 'tertiary' ? "transform: translateY(".concat(offset, "px);") : '';
};

export { applyPrimaryThemeVerticalOffset, primaryButtonBackgroundColor, primaryButtonFontColor, primaryButtonLoadingBackgroundColor, setButtonStyleFontWeight, setSecondaryHeadingFont, setThemeFontWeight, setThemeLineHeight };
